import styled from 'styled-components'
import { defaultBorderRadius, transition } from 'utils/style-utils'

import { BaseGameBox, gameImageAspectRatio } from '../styles'

export const GameBox = styled(BaseGameBox)`
  position: relative;
`

export const LinksBox = styled.div`
  aspect-ratio: ${gameImageAspectRatio};
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: calc(100% - 1rem);
  margin: 0.5rem;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;

  border-radius: ${defaultBorderRadius};
  background: rgba(0, 0, 0, 0.8);

  opacity: 0;
  ${transition('all', 0.3)}

  :hover {
    opacity: 1;
  }
`
